module.exports = __webpack_public_path__ + "static/smb-logo-8e2074704608213bcb6ffd147bcf9230.png";